<template>

</template>

<script>
    export default {
        name: "Question"
    }
</script>

<style scoped>

</style>